var countUpfn = function (el) {
    var countUpFlag = false;
    return function () {
        if(!countUpFlag) {
            var scrollY = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            if(scrollY >= 1000) {
                $(el).countup({
                    useGrouping: true
                });
                countUpFlag = true;
            }
        }
    }
}
window.countUpfn = countUpfn;